import type { SharableOpportunity } from 'backend/types'
import { useCallback, useMemo, useState } from 'react'
import { filterPublicOpportunities } from '../-lib/public-opportunity-filter'

/**
 * 公開オポチュニティ一覧ページの状態管理フック
 *
 * 公開オポチュニティ一覧ページで使用する検索状態とフィルタリングロジックを管理します。
 * シンプル検索とカスタム検索（含む/含まない）の両方をサポートします。
 */
export function usePublicOpportunitiesPageState(opportunities: SharableOpportunity[] | undefined) {
  // シンプル検索（テキストボックス）
  const [searchText, setSearchText] = useState('')

  // カスタム検索（含む/含まない）
  const [customSearchQuery, setCustomSearchQuery] = useState('')
  const [customSearchExclude, setCustomSearchExclude] = useState('')

  // カスタム検索ハンドラー
  const handleCustomSearch = useCallback((query: string, exclude: string) => {
    setCustomSearchQuery(query)
    setCustomSearchExclude(exclude)
  }, [])

  // カスタム検索クリアハンドラー
  const handleCustomSearchClear = useCallback(() => {
    setCustomSearchQuery('')
    setCustomSearchExclude('')
  }, [])

  // 検索テキストでフィルタリング
  const filteredOpportunities = useMemo(
    () => filterPublicOpportunities(opportunities ?? [], searchText, customSearchQuery, customSearchExclude),
    [opportunities, searchText, customSearchQuery, customSearchExclude],
  )

  return {
    // 検索状態
    searchText,
    setSearchText,

    // フィルタリング済みデータ
    filteredOpportunities,

    // カスタム検索ハンドラー
    handleCustomSearch,
    handleCustomSearchClear,
  }
}
